export default "__VITE_ASSET__BKZLo3sM__"